import { render } from "./Com_Accnt.vue?vue&type=template&id=0c2b0f11&scoped=true"
import script from "./Com_Accnt.vue?vue&type=script&lang=js"
export * from "./Com_Accnt.vue?vue&type=script&lang=js"

import "./Com_Accnt.vue?vue&type=style&index=0&id=0c2b0f11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2b0f11"]])

export default __exports__